import React from "react";

const Upload2LineIcon = () => (
	<g>
		<path d='M4 19H20V12H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V12H4V19ZM13 9V16H11V9H6L12 3L18 9H13Z' />
	</g>
);

export default Upload2LineIcon;
